// Scrollbar contract for preview documents, shared by the responsive preview and the
// page-builder canvas so both surfaces expose the same usable viewport at a given
// device width. At the handheld widths (mobile, tablet) the document's scrollbar is
// hidden, matching a real handheld's overlay scrollbar — a classic scrollbar would
// narrow the usable viewport below the device width and change every cover-fit crop.
// Desktop widths keep the browser's own scrollbar behaviour.
(function () {
  var STYLE_ID = "sparkle-preview-viewport-scrollbar";
  var HANDHELD_DEVICE_TYPES = ["mobile", "tablet"];

  window.Sparkle = window.Sparkle || {};
  window.Sparkle.PreviewViewportScrollbar = {
    // Applies the contract for deviceType to the given preview document. Reapplying
    // with a new deviceType replaces the previous state, so callers can invoke it on
    // every device switch and document (re)load.
    apply: function (doc, deviceType) {
      if (!doc || !doc.head) {
        return;
      }

      var existing = doc.getElementById(STYLE_ID);

      if (existing) {
        existing.remove();
      }

      if (HANDHELD_DEVICE_TYPES.indexOf(deviceType) === -1) {
        return;
      }

      var style = doc.createElement("style");
      style.id = STYLE_ID;
      style.textContent = "::-webkit-scrollbar { display: none; } html { scrollbar-width: none; }";
      doc.head.appendChild(style);
    },
  };
})();
